/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Delete_Empty_HintInputs */

const cs_settings_venues_delete_empty_hint = /** @type {(inputs: Settings_Venues_Delete_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na této pobočce nikdo není, takže není třeba nikoho přesouvat.`)
};

const en_settings_venues_delete_empty_hint = /** @type {(inputs: Settings_Venues_Delete_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This venue has no people, so nothing needs to be reassigned.`)
};

/**
* | output |
* | --- |
* | "This venue has no people, so nothing needs to be reassigned." |
*
* @param {Settings_Venues_Delete_Empty_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_delete_empty_hint = /** @type {((inputs?: Settings_Venues_Delete_Empty_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Delete_Empty_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_delete_empty_hint(inputs)
	return cs_settings_venues_delete_empty_hint(inputs)
});